import { StrictMode } from 'react';

import ReactDOM from 'react-dom/client';
import '@scaleaq/scaleui/reset.css';

import '@/localization/i18n.ts';
import '@fontsource-variable/inter';
import '@fontsource-variable/roboto';
import '@scaleaq/sui-tokens/tokens.css';

import '@/css.styles/styles.css';
import '@/css.styles/reset.css';
import { App } from '@/App.tsx';
import { AuthenticationProvider } from '@/providers';
import { useConfigStore } from '@/stores';
import { initConfigStore } from '@/utils';
import { initFrontendLogs } from '@/utils/frontendLogs.ts';

import { reportWebVitals } from './reportWebVitals.ts';

void initConfigStore().then(() => initFrontendLogs(useConfigStore.getState()));

// Render the app
const rootElement = document.getElementById('app');
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <StrictMode>
      <AuthenticationProvider>
        <App />
      </AuthenticationProvider>
    </StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
